export const getCompanyFilterText = (value) => (
    typeof value === "string" ? value.replace(/%$/, "") : ""
);

export const findCompanyFilter = (where) => {
    if (!where || typeof where !== "object") return undefined;

    if (where.column === "COMPANY" && where.operator === "LIKE" && typeof where.value === "string")
    {
        return where;
    }

    for (const condition of [ "AND", "OR" ])
    {
        for (const child of where[ condition ] || [])
        {
            const match = findCompanyFilter(child);
            if (match) return match;
        }
    }

    return undefined;
};

export const expandUserCompanyFilter = (where, pattern, subcontractorIDs) => {
    if (!where || !subcontractorIDs.length) return where;

    const expanded = { ...where };
    for (const condition of [ "AND", "OR" ])
    {
        if (Array.isArray(where[ condition ]))
        {
            expanded[ condition ] = where[ condition ].map(child => (
                expandUserCompanyFilter(child, pattern, subcontractorIDs)
            ));
        }
    }

    if (expanded.column !== "COMPANY" || expanded.operator !== "LIKE" || expanded.value !== pattern)
    {
        return expanded;
    }

    const { column, operator, value, ...siblings } = expanded;
    const companyMatch = {
        OR: [
            { column, operator, value },
            { column: "SUBCONTRACTOR_ID", operator: "IN", value: subcontractorIDs },
        ],
    };

    return Object.keys(siblings).length ? { AND: [ companyMatch, siblings ] } : companyMatch;
};
